import(/* webpackMode: "eager", webpackExports: ["LandingPage"] */ "/app/src/app/[locale]/_components/landing-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmoothScroll"] */ "/app/src/app/[locale]/_components/smooth-scroll.tsx");
